import { Spacer } from '@sparemin/blockhead';
import React from 'react';
import Button from 'components/Button';
import Tooltip from 'components/Tooltip';
import { useTemplateState } from '../context/VideoTemplateStateContext';
import { captionsViewBlock as block } from '../utils';
import { useCaptionsChildViewContext } from './CaptionsChildViewContext';
import CaptionsChildViewTranscriptionProgress from './CaptionsChildViewTranscriptionProgress';

export type CaptionsChildViewEditCaptionTextButtonProps = {
  label?: React.ReactNode;
};

const CaptionsChildViewEditCaptionTextButton: React.FC<CaptionsChildViewEditCaptionTextButtonProps> = ({
  label = 'edit caption text',
}) => {
  const { transcription } = useTemplateState();

  const {
    isLoadingMediaInfo,
    isTranscribing,
    eddyProjectCuid,
    onEditCaptionText,
  } = useCaptionsChildViewContext();

  const isDisabled = isLoadingMediaInfo || isTranscribing || !eddyProjectCuid;

  return (
    <Spacer
      space="8px"
      orientation="vertical"
      align="center"
      justify="space-between"
      className={block('edit-caption-text-button-container')}
    >
      {(isTranscribing || isLoadingMediaInfo) && (
        <CaptionsChildViewTranscriptionProgress />
      )}

      <Tooltip
        content={
          <>
            Editing is only available once captions are generated which can take
            up to 1/3 the length of the video to complete.
            <br />
            You can also access caption editing later through your Projects.
          </>
        }
        placement="bottom"
        show={isDisabled ? undefined : false}
      >
        <Button
          fluid
          theme="submit"
          disabled={isDisabled || !transcription?.transcribe}
          onClick={onEditCaptionText}
        >
          {label}
        </Button>
      </Tooltip>
    </Spacer>
  );
};

export default CaptionsChildViewEditCaptionTextButton;
